import React from 'react';
import { Eye, Users, Calendar, MousePointer, TrendingUp, TrendingDown, Activity } from 'lucide-react';

const MetricsSummary = ({ stats, extendedStats }) => {
  const weeklyChange = extendedStats?.weeklyComparison?.change || 0;
  const isPositive = weeklyChange >= 0;

  const avgDailyViews = stats.totalViews > 0 
    ? Math.round(stats.totalViews / Math.max(stats.last7DaysViews?.length || 7, 1)) 
    : 0;

  const cards = [
    {
      id: 'views',
      label: 'TOTAL VIEWS',
      value: stats.totalViews || 0,
      icon: <Eye className="metric-icon" />,
      color: '#00FFD1',
      bgGlow: 'rgba(0, 255, 209, 0.12)'
    },
    {
      id: 'visitors',
      label: 'UNIQUE VISITORS',
      value: stats.uniqueVisitors || 0,
      icon: <Users className="metric-icon" />,
      color: '#00D4FF',
      bgGlow: 'rgba(0, 212, 255, 0.12)'
    },
    {
      id: 'today',
      label: "TODAY'S VIEWS",
      value: stats.todayViews || 0,
      icon: <Calendar className="metric-icon" />,
      color: '#A78BFA',
      bgGlow: 'rgba(167, 139, 250, 0.12)'
    },
    {
      id: 'clicks',
      label: 'PROJECT CLICKS',
      value: stats.projectClicks || 0,
      icon: <MousePointer className="metric-icon" />,
      color: '#F472B6',
      bgGlow: 'rgba(244, 114, 182, 0.12)'
    },
    {
      id: 'avg',
      label: 'AVG DAILY VIEWS',
      value: avgDailyViews,
      icon: <Activity className="metric-icon" />,
      color: '#34D399',
      bgGlow: 'rgba(52, 211, 153, 0.12)'
    },
    {
      id: 'trend',
      label: 'WEEKLY TREND',
      value: `${isPositive ? '+' : ''}${weeklyChange}%`,
      icon: isPositive ? <TrendingUp className="metric-icon green" /> : <TrendingDown className="metric-icon red" />,
      color: isPositive ? '#34D399' : '#F87171',
      bgGlow: isPositive ? 'rgba(52, 211, 153, 0.12)' : 'rgba(248, 113, 113, 0.12)'
    }
  ];

  return (
    <div className="metrics-grid">
      {cards.map((card) => (
        <div key={card.id} className="metric-card" style={{ '--card-glow': card.bgGlow, '--card-accent': card.color }}>
          <div className="metric-card-header">
            <span className="metric-label">{card.label}</span>
            <div className="metric-icon-box" style={{ color: card.color }}>
              {card.icon}
            </div>
          </div>
          <div className="metric-card-body">
            <span className="metric-value" style={{ color: card.color }}>
              {card.value}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsSummary;
